import { Snackbar as MuiSnackbar, useTheme } from '@mui/material';

import { DEFAULT_NOTIFICATION_DURATION } from 'shared/constants/notifications';

import type { SnackbarProps } from '@mui/material';
import type { FC } from 'react';

export const SNACKBAR_TEST_ID = 'snackbar';

export const Snackbar: FC<SnackbarProps> = props => {
  const { spacing } = useTheme();

  return (
    <MuiSnackbar
      data-testid={SNACKBAR_TEST_ID}
      autoHideDuration={DEFAULT_NOTIFICATION_DURATION}
      sx={{ right: { md: spacing(4) }, bottom: { md: spacing(12.5) } }}
      ContentProps={{ sx: { minWidth: { sm: 456 }, py: spacing(0.25) } }}
      {...props}
    />
  );
};
